import { gql } from '@apollo/client';

export const GET_PERMISSIONS_FOR_CURRENT_USER = gql`
  query GetPermissionsForCurrentUser {
    getPermissionsForCurrentUser
  }
`;
